export class EmployStatus {
    EmpStatus;
    CDesc;
    EDesc;
    constructor() {
      this.EmpStatus = "";
      this.CDesc = "";
      this.EDesc = "";
    }
  }
  


// WEBPACK FOOTER //
// ./src/model/EmployStatus.js